/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { UsageReportsContext } from '../contexts';

export const useUsageReportsStore = () => useContext(UsageReportsContext);
